import { FormProvider, useForm } from "react-hook-form";
import { Form as SemanticForm } from "semantic-ui-react";

import type { PropsWithChildren } from "react";
import type { FieldValues } from "react-hook-form";
import type { FormProps } from "semantic-ui-react";

interface FormFacadeProps<T extends FieldValues> extends PropsWithChildren {
  formProps?: FormProps;
  defaultValues?: T | undefined;
  onSubmit?: (data: T) => void;
}

export const Form = <T extends FieldValues>({ onSubmit, defaultValues, formProps, children }: FormFacadeProps<T>) => {
  const methods = useForm<T>({ values: defaultValues, resetOptions: { keepDirtyValues: true }, mode: "all" });

  return (
    <FormProvider {...methods}>
      <SemanticForm
        loading={methods.formState.isSubmitting}
        onSubmit={onSubmit ? methods.handleSubmit(onSubmit) : undefined}
        {...formProps}
        disabled={methods.formState.isSubmitting}
      >
        {children}
      </SemanticForm>
    </FormProvider>
  );
};
